
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCellular = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.36 5.72c.395 0 .787.164 1.086.481l1.427 1.515c.311.335.465.771.468 1.207a1.78 1.78 0 0 1-.445 1.205 2.26 2.26 0 0 0-.602 1.334c-.047.488.06.993.332 1.434a10.8 10.8 0 0 0 2.879 3.053c.428.307.928.428 1.411.378.48-.05.946-.27 1.3-.647a1.495 1.495 0 0 1 1.084-.47 1.49 1.49 0 0 1 1.079.478l1.428 1.517c.317.337.472.78.473 1.22 0 .44-.155.882-.471 1.219l-.405.43c-.801.806-1.871 1.242-2.975 1.203-2.079 0-4.587-1.168-7.09-3.827-1.965-2.088-3.062-4.18-3.454-6.046-.415-1.976-.033-3.691.978-4.766l.41-.436c.3-.318.693-.482 1.087-.482z",
  stroke: "#000",
  strokeWidth: 1.441
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.363 11.31a7.548 7.548 0 0 0-2.248-5.544 7.275 7.275 0 0 0-5.413-2.099m4.388 7.493a4.19 4.19 0 0 0-1.25-2.996 4.042 4.042 0 0 0-2.949-1.168",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.703,
  strokeLinecap: "round"
}))));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path d=\"M5.36 5.72c.395 0 .787.164 1.086.481l1.427 1.515c.311.335.465.771.468 1.207.003.437-.147.876-.445 1.205-.349.37-.554.842-.602 1.334-.047.488.06.993.332 1.434a10.8 10.8 0 0 0 2.879 3.053c.428.307.928.428 1.411.378.48-.05.946-.27 1.3-.647a1.495 1.495 0 0 1 1.084-.47c.392.001.782.164 1.079.478l1.428 1.517c.317.337.472.78.473 1.22 0 .44-.155.882-.471 1.219l-.405.43c-.801.806-1.871 1.242-2.975 1.203-2.079 0-4.587-1.168-7.09-3.827-1.965-2.088-3.062-4.18-3.454-6.046-.415-1.976-.033-3.691.978-4.766l.41-.436c.3-.318.693-.482 1.087-.482z\" stroke=\"#000\" stroke-width=\"1.441\"/>\r\n        <path d=\"M20.363 11.31a7.548 7.548 0 0 0-2.248-5.544 7.275 7.275 0 0 0-5.413-2.099M17.09 11.16c0-1.09-.419-2.18-1.25-2.996a4.042 4.042 0 0 0-2.949-1.168\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.703\" stroke-linecap=\"round\"/>\r\n    </g>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/cellular.c61ef45b3cd83ebcdf40a17fa0394d71.svg"),
        {
          React: SvgCellular,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      